import { AsyncPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as Rx from 'rxjs';

// FIXME: switch back to async after https://github.com/angular/angular/issues/16982
// eslint-disable-next-line @angular-eslint/no-pipe-impure
@Pipe({ name: 'flAsync', pure: false })
export class FreelancerAsyncPipe extends AsyncPipe implements PipeTransform {
  transform<T>(obj$: null | undefined): undefined;
  transform<T>(
    obj$: Promise<T> | Rx.Subscribable<T> | null | undefined,
  ): T | undefined;
  transform<T>(obj$: any): T | undefined {
    return super.transform<T>(obj$) ?? undefined;
  }
}
